import { render, staticRenderFns } from "./_inclusions.vue?vue&type=template&id=1d698f7e&scoped=true"
import script from "./_inclusions.vue?vue&type=script&lang=js"
export * from "./_inclusions.vue?vue&type=script&lang=js"
import style0 from "./_inclusions.vue?vue&type=style&index=0&id=1d698f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d698f7e",
  null
  
)

export default component.exports